import React from "react";
import { GlobalFonts } from "./src/styles/globals/fonts";
import { captureAttribution } from "./src/utils/attribution";

const CONSENT_KEY = "homecare_life_cookie_consent";

export const wrapRootElement = ({ element }) => (
  <div>
    <GlobalFonts />
    {element}
  </div>
);

export const onInitialClientRender = () => {
  captureAttribution();

  const consent = localStorage.getItem(CONSENT_KEY);

  if (consent === "granted" && typeof window.gtag === "function") {
    window.gtag("consent", "update", {
      analytics_storage: "granted",
      ad_storage: "granted",
      ad_user_data: "granted",
      ad_personalization: "granted",
    });
  }
};
